import { useState } from 'react'
import { Button } from 'components/atoms/button'
import { ContentModal } from 'components/organisms/modals/content-modal'

interface FilterChangeWarningModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	visibleContactsCount: number
	onContinueWithFilter: () => void
	onCancel: () => void
}

export function FilterChangeWarningModal({
	open,
	setOpen,
	visibleContactsCount,
	onContinueWithFilter,
	onCancel,
}: FilterChangeWarningModalProps) {
	return (
		<ContentModal open={open} setOpen={setOpen} isModal title="Filter Change Warning">
			<div className="relative flex flex-col items-center space-y-5">
				<div className="w-full text-center">
					<div className="text-primary-text mb-6">
						You currently have <strong>all contacts selected</strong>. When you apply this filter, only the{' '}
						<strong>
							{visibleContactsCount} visible contact{visibleContactsCount !== 1 ? 's' : ''}
						</strong>{' '}
						will be kept in your selection.
					</div>

					<div className="space-y-3">
						<Button variant="primary" fullWidth size="lg" onClick={onContinueWithFilter}>
							Continue with Filter
						</Button>
						<Button variant="secondary" fullWidth size="lg" onClick={onCancel}>
							Cancel
						</Button>
					</div>
				</div>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface FilterChangeWarningModalManagedProps {
	visibleContactsCount: number
	onContinueWithFilter: () => void
	onCancel?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'filter-change-warning': FilterChangeWarningModalManagedProps
	}
}

export function ManagedFilterChangeWarningModal({
	onClose,
	onContinueWithFilter,
	onCancel,
	...rest
}: FilterChangeWarningModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<FilterChangeWarningModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onContinueWithFilter={() => { onContinueWithFilter(); handleClose() }}
			onCancel={() => { onCancel?.(); handleClose() }}
			{...rest}
		/>
	)
}
